import React from "react";
import styles from "./NoMatchFoundStyles.module.css";

export const NoMatchFound = () => {
  const textStyle={
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '300',
    lineHeight: '24px',
    textAlign: 'left',
    color: '#5C667B'
}
  return (
    <>
      <div>
        <div className={styles.layoutNoMatchingAnswers} style={{border:'none'}}>
          <div className="row mt-1">
            <div className="col-md-3 text-center" style={{display:'flex',alignItems:'center'}}>
              <img
                src={require("../../Images/expert-rev.png")}
                className={styles.imageNoMatching}
              />
            </div>
            <div className="col-md-9">
              <h3 className={styles.titleNoMatching}>
                No Matching answers found.
              </h3>
              <h5 style={textStyle}>Please try following:</h5>
              <h5 className={styles.textMatchingAnswers}>
                Frame your question with different keywords
              </h5>
              <h5 className={styles.textMatchingAnswers}>
                Make question self explanatory
              </h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
